import script from "./TradeData.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeData.vue?vue&type=script&setup=true&lang=js"

import "./TradeData.vue?vue&type=style&index=0&id=e7feab7e&lang=scss"

const __exports__ = script;

export default __exports__